import { render, staticRenderFns } from "./TeamProfileAbout.vue?vue&type=template&id=036280ca&scoped=true&"
import script from "./TeamProfileAbout.vue?vue&type=script&lang=js&"
export * from "./TeamProfileAbout.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "036280ca",
  null
  
)

export default component.exports